var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconWallet2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5188 53.7149L11.5188 53.7149C9.60994 55.4688 9.60994 58.3124 11.5188 60.0663L46.082 91.8233C47.9909 93.5772 51.0858 93.5772 52.9947 91.8233C54.9035 90.0694 54.9035 87.2258 52.9946 85.4719L18.4315 53.7149C16.5226 51.961 13.4277 51.961 11.5188 53.7149Z",
    fill: "#E41B9F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.2889 29.0192L21.9577 12.7849C33.6538 2.03838 47.0089 2.87677 57.4608 12.4802C58.7883 13.6996 60.4471 15.8336 61.4427 17.2055C61.8575 17.7391 62.1061 18.1202 62.438 18.4249C63.1017 19.0348 63.7652 19.1872 65.1754 18.8061C73.8855 16.5959 81.517 19.0348 88.8167 25.7418C99.0197 35.1164 100.098 47.6922 87.1577 59.5821L62.355 82.371C61.0278 83.5905 59.9496 83.5142 58.6224 82.2948L4.37184 32.4488C3.04462 31.2294 2.96168 30.2386 4.2889 29.0192ZM40.5408 37.6315L44.7713 33.7442C46.9281 31.7627 47.2597 29.0189 44.6883 26.6563C42.1999 24.3696 39.1306 24.5983 36.9738 26.5801L32.7433 30.4671C31.4161 31.6865 31.4991 32.6773 32.8263 33.8967L36.8079 37.5553C38.1351 38.7747 39.2136 38.8509 40.5408 37.6315ZM60.7811 56.2305L71.8967 46.0173C75.1319 43.0448 75.7956 40.301 73.058 37.7859C70.4036 35.3471 67.3344 35.8804 64.0992 38.8529L52.9839 49.066C51.6564 50.2855 51.7394 51.2762 53.0666 52.4957L57.0484 56.1542C58.3756 57.3737 59.4539 57.4499 60.7811 56.2305Z",
    fill: "#2926CF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWallet2);
export default __webpack_public_path__ + "static/media/icon-wallet-2.ea55944e700281c6f7f372044f7cc5dd.svg";
export { ForwardRef as ReactComponent };